"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISTRICT_ATTORNEY_PENSION = exports.HOUSE_OF_CORRECTIONS_EMPLOYEES = exports.COURT_EMPLOYEES_PENSIONS = exports.JUDGES_PENSIONS = exports.GENERAL_ASSEMBLY_MEMBERS_PENSIONS = exports.LEGISLATORS_PENSIONS = exports.MUNICIPAL_EMPLOYEES_PENSION = exports.COUNTY_EMPLOYEES_PENSION = exports.NONPROFIT_WORKER_RETIREMENT = exports.TEACHERS_PENSION = exports.FEDERAL_PUBLIC_EMPLOYEE = exports.ERISA_REITREMENT_PLAN = exports.STATE_EMPLOYEES_PENSION = exports.FIREFIGHTERS_PENSION = exports.DISTRICT_EMPLOYEES_PENSION = exports.BOARD_OF_REGENTS_PENSION = exports.PUBLIC_EMPLOYEE_PENSION = exports.SHERIFF_PENSION = exports.POLICE_PENSION = exports.RANGERS_PENSION = exports.PIANO_OR_ORGAN = exports.ROTH_IRA = exports.TRADITIONAL_IRA = exports.SIMPLE_IRA = exports.EDUCATIONAL_IRA = exports.LIFE_INSURANCE_EMPLOYER = exports.INDUSTRIAL_WORKERS_COMP_INSURANCE = exports.WORKERS_COMP_INSURANCE = exports.WHOLE_INSURANCE_PLAN = exports.UNMATURED_TERM_INSURANCE_POLICY = exports.OLD_AGE_SURVIVORS_INSURANCE = exports.LIFE_INSURANCE_PROCEEDS = exports.LIFE_INSURANCE_PLAN = exports.LIFE_INSURANCE_PAYMENTS_FOR_PUBLIC_EMPLOYEES = exports.LIFE_INSURANCE_PAYMENTS_FOR_DEPENDEE = exports.INHERITANCE_AND_ESTATE = exports.INDUSTRIAL_LIFE_INSURANCE = exports.HOMEOWNERS_INSURANCE_PROCEEDS = exports.HEALTH_ACCIDENT_DISABILITY_PROCEEDS = exports.HAIL_INSURANCE = exports.GROUP_INSURANCE_PROCEEDS = exports.GROUP_INSURANCE_PLAN = exports.FINANCIAL_INTERESTS = exports.DISASTER_INSURANCE_PROCEEDS = exports.ACCIDENT_INSURANCE = exports.SUPPLEMENTAL_STATE_FAIR_RELIEF = exports.OHIO_WORKS_PROGRAM = exports.FIREFIGHTERS_BENEFITS = exports.POLICE_BENEFITS = exports.MUNICIPAL_EMPLOYEES_BENEFITS = exports.STATE_EMPLOYEES_BENEFITS = exports.HIGHER_EDUCATION_BENEFITS = exports.RELOCATION_ASSISTANCE = exports.AID_TO_DEPENDENT_CHILDREN = exports.AID_TO_BLIND = exports.ADOPTED_CHILD_ASSISTANCE = exports.PUBLIC_CHILD_ASSISTANCE = exports.VOCATIONAL_REHABILITATION_BENEFITS = exports.STATE_WELFARE = exports.HEALTH_BENEFITS = exports.REHABILITATION_ACT_MAINTENANCE = exports.DEATH_BENEFITS = exports.DISABILITY_BENEFITS = exports.VETERANS_COMPENSATION = exports.VETERANS_BENEFITS = exports.LOCAL_PUBLIC_ASSISTANCE_BENEFIT = exports.UNEMPLOYMENT_BENEFITS = exports.UNEMPLOYMENT_COMPENSATION = exports.SOCIAL_SECURITY = exports.SEWING_MACHINE = exports.MICROWAVE = exports.FREEZER = exports.REFRIGERATOR = exports.CLOTHES_WASHER_DRYER = exports.FURNACE = exports.STOVE = exports.BEDDING = exports.CARPET = exports.DINING_KITCHEN_FURNITURE = exports.SOFA = exports.MORTGAGE_IMPOUND_ACCOUNT = exports.FIREMANS_DISABILITY_BENEFITS = exports.OTHER_DEPOSIT = exports.FUNERAL_DEPOSITS = exports.RENTED_FURNITURE_DEPOSIT = exports.WATER_DEPOSIT = exports.TELEPHONE_DEPOSIT = exports.OTHER_PREPAYMENT = exports.PREPAID_RENT = exports.SECURITY_DEPOSIT = exports.HEATING_OIL_DEPOSIT = exports.GAS_DEPOSIT = exports.ELECTRIC_DEPOSIT = exports.INTEREST_FROM_DEATH_EMERGENCY_PERSONNEL = exports.FURS = exports.GEOLOGY_PALEONTOLOGY_COLLECTIONS = exports.MINING_ASSETS = exports.PROFESSIONAL_LIBRARY = exports.STOCK_BONUS = exports.ANNUITIES_FOR_DEPENDENT = void 0;
exports.SCHOOLBOOKS = exports.THRIFT_SAVINGS_PLAN = exports.ILLINOIS_COLLEGE_SAVINGS_POOL_ACCOUNT = exports.HURRICANE_SAVINGS_ACCOUNT = exports.SOUTH_CAROLINA_TUITION_PREPAYMENT_PROGRAM = exports.TUITION_PROGRAM = exports.CEMETARY_MERCHANDISE_TRUST = exports.PREPAID_COLLEGE_TRUST = exports.PERPETUAL_CARE_TRUST = exports.FUNERAL_TRUST = exports.TUITION_TRUST = exports.SPENDTHRIFT_TRUST = exports.LOCAL_TAX_REFUND = exports.STATE_TAX_REFUND = exports.FEDERAL_TAX_REFUND = exports.CHILD_CREDIT = exports.INCOME_TAX_CREDIT = exports.PRIVATE_STOCK = exports.PUBLIC_STOCK = exports.CONSERVATION_OFFICER = exports.OLD_AGE_ASSISTANCE = exports.BAGGAGE_KEEPERS = exports.VOTING_REGISTRAR_PENSION = exports.VOLUNTEER_FIREFIGHTERS_DEPENDENTS_FUND = exports.SCHOOL_EMPLOYEE_PENSION = exports.PAROCHIAL_EMPLOYEE_PENSION = exports.PUBLIC_SCHOOL_EMPLOYEE_PENSIONS = exports.HIGHWAY_PATROL_PENSION = exports.PRIVATE_PENSION_PLAN = exports.ASSESSORS_PENSION = void 0; // Annuities

var ANNUITIES_FOR_DEPENDENT = 'annuities_for_dependent';
exports.ANNUITIES_FOR_DEPENDENT = ANNUITIES_FOR_DEPENDENT;
var STOCK_BONUS = 'stock_bonus'; // NOTE - Nested under bucket, not a specific type. Make these subtypes?
// Business assets

exports.STOCK_BONUS = STOCK_BONUS;
var PROFESSIONAL_LIBRARY = 'professional_library';
exports.PROFESSIONAL_LIBRARY = PROFESSIONAL_LIBRARY;
var MINING_ASSETS = 'mining_assets';
exports.MINING_ASSETS = MINING_ASSETS;
var GEOLOGY_PALEONTOLOGY_COLLECTIONS = 'geology_palentology_collections'; // Clothes

exports.GEOLOGY_PALEONTOLOGY_COLLECTIONS = GEOLOGY_PALEONTOLOGY_COLLECTIONS;
var FURS = 'furs'; // Interest from Death

exports.FURS = FURS;
var INTEREST_FROM_DEATH_EMERGENCY_PERSONNEL = 'interest_from_death_emergency_personnel'; // Deposit

exports.INTEREST_FROM_DEATH_EMERGENCY_PERSONNEL = INTEREST_FROM_DEATH_EMERGENCY_PERSONNEL;
var ELECTRIC_DEPOSIT = 'electric_deposit';
exports.ELECTRIC_DEPOSIT = ELECTRIC_DEPOSIT;
var GAS_DEPOSIT = 'gas_deposit';
exports.GAS_DEPOSIT = GAS_DEPOSIT;
var HEATING_OIL_DEPOSIT = 'heating_oil_deposit';
exports.HEATING_OIL_DEPOSIT = HEATING_OIL_DEPOSIT;
var SECURITY_DEPOSIT = 'security_deposit';
exports.SECURITY_DEPOSIT = SECURITY_DEPOSIT;
var PREPAID_RENT = 'prepaid_rent';
exports.PREPAID_RENT = PREPAID_RENT;
var OTHER_PREPAYMENT = 'other_prepayment';
exports.OTHER_PREPAYMENT = OTHER_PREPAYMENT;
var TELEPHONE_DEPOSIT = 'telephone_deposit';
exports.TELEPHONE_DEPOSIT = TELEPHONE_DEPOSIT;
var WATER_DEPOSIT = 'water_deposit';
exports.WATER_DEPOSIT = WATER_DEPOSIT;
var RENTED_FURNITURE_DEPOSIT = 'rented_furniture_deposit';
exports.RENTED_FURNITURE_DEPOSIT = RENTED_FURNITURE_DEPOSIT;
var FUNERAL_DEPOSITS = 'funeral_deposits';
exports.FUNERAL_DEPOSITS = FUNERAL_DEPOSITS;
var OTHER_DEPOSIT = 'other_deposit'; // NOTE - What is this nested under????
// Diability

exports.OTHER_DEPOSIT = OTHER_DEPOSIT;
var FIREMANS_DISABILITY_BENEFITS = 'firemans_disability_benefits'; // Escrow

exports.FIREMANS_DISABILITY_BENEFITS = FIREMANS_DISABILITY_BENEFITS;
var MORTGAGE_IMPOUND_ACCOUNT = 'mortgage_impound_account'; // Household - Furniture

exports.MORTGAGE_IMPOUND_ACCOUNT = MORTGAGE_IMPOUND_ACCOUNT;
var SOFA = 'sofa';
exports.SOFA = SOFA;
var DINING_KITCHEN_FURNITURE = 'dining_kitchen_furniture';
exports.DINING_KITCHEN_FURNITURE = DINING_KITCHEN_FURNITURE;
var CARPET = 'carpet';
exports.CARPET = CARPET;
var BEDDING = 'bedding'; // Household - Appliances

exports.BEDDING = BEDDING;
var STOVE = 'stove';
exports.STOVE = STOVE;
var FURNACE = 'furnace';
exports.FURNACE = FURNACE;
var CLOTHES_WASHER_DRYER = 'clothes_washer_dryer';
exports.CLOTHES_WASHER_DRYER = CLOTHES_WASHER_DRYER;
var REFRIGERATOR = 'refrigerator';
exports.REFRIGERATOR = REFRIGERATOR;
var FREEZER = 'freezer';
exports.FREEZER = FREEZER;
var MICROWAVE = 'microwave';
exports.MICROWAVE = MICROWAVE;
var SEWING_MACHINE = 'sewing_machine'; // Public Assitance

exports.SEWING_MACHINE = SEWING_MACHINE;
var SOCIAL_SECURITY = 'social_security';
exports.SOCIAL_SECURITY = SOCIAL_SECURITY;
var UNEMPLOYMENT_COMPENSATION = 'unemployment_compensation';
exports.UNEMPLOYMENT_COMPENSATION = UNEMPLOYMENT_COMPENSATION;
var UNEMPLOYMENT_BENEFITS = 'unemployment_benefits';
exports.UNEMPLOYMENT_BENEFITS = UNEMPLOYMENT_BENEFITS;
var LOCAL_PUBLIC_ASSISTANCE_BENEFIT = 'local_public_assistance_benefits';
exports.LOCAL_PUBLIC_ASSISTANCE_BENEFIT = LOCAL_PUBLIC_ASSISTANCE_BENEFIT;
var VETERANS_BENEFITS = 'veterans_benefits';
exports.VETERANS_BENEFITS = VETERANS_BENEFITS;
var VETERANS_COMPENSATION = 'veterans_compensation';
exports.VETERANS_COMPENSATION = VETERANS_COMPENSATION;
var DISABILITY_BENEFITS = 'disability_benefits';
exports.DISABILITY_BENEFITS = DISABILITY_BENEFITS;
var DEATH_BENEFITS = 'death_benefits';
exports.DEATH_BENEFITS = DEATH_BENEFITS;
var REHABILITATION_ACT_MAINTENANCE = 'rehabilitation_act_maintenance';
exports.REHABILITATION_ACT_MAINTENANCE = REHABILITATION_ACT_MAINTENANCE;
var HEALTH_BENEFITS = 'health_benefits';
exports.HEALTH_BENEFITS = HEALTH_BENEFITS;
var STATE_WELFARE = 'state_welfare';
exports.STATE_WELFARE = STATE_WELFARE;
var VOCATIONAL_REHABILITATION_BENEFITS = 'vocational_rehabilitation_benefits';
exports.VOCATIONAL_REHABILITATION_BENEFITS = VOCATIONAL_REHABILITATION_BENEFITS;
var PUBLIC_CHILD_ASSISTANCE = 'public_child_assistance';
exports.PUBLIC_CHILD_ASSISTANCE = PUBLIC_CHILD_ASSISTANCE;
var ADOPTED_CHILD_ASSISTANCE = 'adopted_child_assistance';
exports.ADOPTED_CHILD_ASSISTANCE = ADOPTED_CHILD_ASSISTANCE;
var AID_TO_BLIND = 'aid_to_blind';
exports.AID_TO_BLIND = AID_TO_BLIND;
var AID_TO_DEPENDENT_CHILDREN = 'aid_to_dependent_children'; // ...

exports.AID_TO_DEPENDENT_CHILDREN = AID_TO_DEPENDENT_CHILDREN;
var RELOCATION_ASSISTANCE = 'relocation_assistance';
exports.RELOCATION_ASSISTANCE = RELOCATION_ASSISTANCE;
var HIGHER_EDUCATION_BENEFITS = 'higher_education_benefits';
exports.HIGHER_EDUCATION_BENEFITS = HIGHER_EDUCATION_BENEFITS;
var STATE_EMPLOYEES_BENEFITS = 'state_employees_benefits';
exports.STATE_EMPLOYEES_BENEFITS = STATE_EMPLOYEES_BENEFITS;
var MUNICIPAL_EMPLOYEES_BENEFITS = 'municipal_employees_benefits';
exports.MUNICIPAL_EMPLOYEES_BENEFITS = MUNICIPAL_EMPLOYEES_BENEFITS;
var POLICE_BENEFITS = 'police_benefits';
exports.POLICE_BENEFITS = POLICE_BENEFITS;
var FIREFIGHTERS_BENEFITS = 'firefighters_benefits'; // ....

exports.FIREFIGHTERS_BENEFITS = FIREFIGHTERS_BENEFITS;
var OHIO_WORKS_PROGRAM = 'ohio_works_program';
exports.OHIO_WORKS_PROGRAM = OHIO_WORKS_PROGRAM;
var SUPPLEMENTAL_STATE_FAIR_RELIEF = 'supplemental_state_fair_relief'; // Indiana
// Insurance

exports.SUPPLEMENTAL_STATE_FAIR_RELIEF = SUPPLEMENTAL_STATE_FAIR_RELIEF;
var ACCIDENT_INSURANCE = 'accident_insurance';
exports.ACCIDENT_INSURANCE = ACCIDENT_INSURANCE;
var DISASTER_INSURANCE_PROCEEDS = 'disaster_insurance_proceeds';
exports.DISASTER_INSURANCE_PROCEEDS = DISASTER_INSURANCE_PROCEEDS;
var FINANCIAL_INTERESTS = 'financial_interests';
exports.FINANCIAL_INTERESTS = FINANCIAL_INTERESTS;
var GROUP_INSURANCE_PLAN = 'group_insurance_plan';
exports.GROUP_INSURANCE_PLAN = GROUP_INSURANCE_PLAN;
var GROUP_INSURANCE_PROCEEDS = 'group_insurance_proceeds';
exports.GROUP_INSURANCE_PROCEEDS = GROUP_INSURANCE_PROCEEDS;
var HAIL_INSURANCE = 'hail_insurance';
exports.HAIL_INSURANCE = HAIL_INSURANCE;
var HEALTH_ACCIDENT_DISABILITY_PROCEEDS = 'health_accident_disability_proceeds';
exports.HEALTH_ACCIDENT_DISABILITY_PROCEEDS = HEALTH_ACCIDENT_DISABILITY_PROCEEDS;
var HOMEOWNERS_INSURANCE_PROCEEDS = 'homeowners_insurance_proceeds';
exports.HOMEOWNERS_INSURANCE_PROCEEDS = HOMEOWNERS_INSURANCE_PROCEEDS;
var INDUSTRIAL_LIFE_INSURANCE = 'industrial_life_insurance';
exports.INDUSTRIAL_LIFE_INSURANCE = INDUSTRIAL_LIFE_INSURANCE;
var INHERITANCE_AND_ESTATE = 'inheritance_and_estate';
exports.INHERITANCE_AND_ESTATE = INHERITANCE_AND_ESTATE;
var LIFE_INSURANCE_PAYMENTS_FOR_DEPENDEE = 'life_insurance_payments_for_dependee';
exports.LIFE_INSURANCE_PAYMENTS_FOR_DEPENDEE = LIFE_INSURANCE_PAYMENTS_FOR_DEPENDEE;
var LIFE_INSURANCE_PAYMENTS_FOR_PUBLIC_EMPLOYEES = 'life_insurance_payments_for_public_employees';
exports.LIFE_INSURANCE_PAYMENTS_FOR_PUBLIC_EMPLOYEES = LIFE_INSURANCE_PAYMENTS_FOR_PUBLIC_EMPLOYEES;
var LIFE_INSURANCE_PLAN = 'life_insurance_plan'; // NOTE: Should this be a subType?

exports.LIFE_INSURANCE_PLAN = LIFE_INSURANCE_PLAN;
var LIFE_INSURANCE_PROCEEDS = 'life_insurance_proceeds';
exports.LIFE_INSURANCE_PROCEEDS = LIFE_INSURANCE_PROCEEDS;
var OLD_AGE_SURVIVORS_INSURANCE = 'old_age_survivors_insurance';
exports.OLD_AGE_SURVIVORS_INSURANCE = OLD_AGE_SURVIVORS_INSURANCE;
var UNMATURED_TERM_INSURANCE_POLICY = 'unmatured_insurance_policy';
exports.UNMATURED_TERM_INSURANCE_POLICY = UNMATURED_TERM_INSURANCE_POLICY;
var WHOLE_INSURANCE_PLAN = 'whole_insurance_plan'; // NOTE: Life Insurance Proceeds

exports.WHOLE_INSURANCE_PLAN = WHOLE_INSURANCE_PLAN;
var WORKERS_COMP_INSURANCE = 'workers_comp_insurance'; // ...

exports.WORKERS_COMP_INSURANCE = WORKERS_COMP_INSURANCE;
var INDUSTRIAL_WORKERS_COMP_INSURANCE = 'industrial_workers_comp_insurance';
exports.INDUSTRIAL_WORKERS_COMP_INSURANCE = INDUSTRIAL_WORKERS_COMP_INSURANCE;
var LIFE_INSURANCE_EMPLOYER = 'life_insurance_employer'; // export const INDUSTRIAL_SICK_BENEFIT = 'industrial_sick_benefit'; // NOTE: Is this the same as above?
// IRA

exports.LIFE_INSURANCE_EMPLOYER = LIFE_INSURANCE_EMPLOYER;
var EDUCATIONAL_IRA = 'educational_ira';
exports.EDUCATIONAL_IRA = EDUCATIONAL_IRA;
var SIMPLE_IRA = 'simple_ira';
exports.SIMPLE_IRA = SIMPLE_IRA;
var TRADITIONAL_IRA = 'traditional_ira';
exports.TRADITIONAL_IRA = TRADITIONAL_IRA;
var ROTH_IRA = 'roth_ira'; // Musical instrument

exports.ROTH_IRA = ROTH_IRA;
var PIANO_OR_ORGAN = 'piano_or_organ'; // Pensions

exports.PIANO_OR_ORGAN = PIANO_OR_ORGAN;
var RANGERS_PENSION = 'rangers_pension';
exports.RANGERS_PENSION = RANGERS_PENSION;
var POLICE_PENSION = 'police_pension';
exports.POLICE_PENSION = POLICE_PENSION;
var SHERIFF_PENSION = 'sheriff_pension';
exports.SHERIFF_PENSION = SHERIFF_PENSION;
var PUBLIC_EMPLOYEE_PENSION = 'public_employee_pension';
exports.PUBLIC_EMPLOYEE_PENSION = PUBLIC_EMPLOYEE_PENSION;
var BOARD_OF_REGENTS_PENSION = 'board_of_regents_pension';
exports.BOARD_OF_REGENTS_PENSION = BOARD_OF_REGENTS_PENSION;
var DISTRICT_EMPLOYEES_PENSION = 'district_employees_pension';
exports.DISTRICT_EMPLOYEES_PENSION = DISTRICT_EMPLOYEES_PENSION;
var FIREFIGHTERS_PENSION = 'firefighters_pension';
exports.FIREFIGHTERS_PENSION = FIREFIGHTERS_PENSION;
var STATE_EMPLOYEES_PENSION = 'state_employees_pension';
exports.STATE_EMPLOYEES_PENSION = STATE_EMPLOYEES_PENSION;
var ERISA_REITREMENT_PLAN = 'erisa_retirement_plan';
exports.ERISA_REITREMENT_PLAN = ERISA_REITREMENT_PLAN;
var FEDERAL_PUBLIC_EMPLOYEE = 'federal_public_employee';
exports.FEDERAL_PUBLIC_EMPLOYEE = FEDERAL_PUBLIC_EMPLOYEE;
var TEACHERS_PENSION = 'teachers_pension';
exports.TEACHERS_PENSION = TEACHERS_PENSION;
var NONPROFIT_WORKER_RETIREMENT = 'nonprofit_worker_retirement';
exports.NONPROFIT_WORKER_RETIREMENT = NONPROFIT_WORKER_RETIREMENT;
var COUNTY_EMPLOYEES_PENSION = 'county_employees_pension';
exports.COUNTY_EMPLOYEES_PENSION = COUNTY_EMPLOYEES_PENSION;
var MUNICIPAL_EMPLOYEES_PENSION = 'municipal_employees_pension';
exports.MUNICIPAL_EMPLOYEES_PENSION = MUNICIPAL_EMPLOYEES_PENSION;
var LEGISLATORS_PENSIONS = 'legislators_pensions';
exports.LEGISLATORS_PENSIONS = LEGISLATORS_PENSIONS;
var GENERAL_ASSEMBLY_MEMBERS_PENSIONS = 'general_assembly_members_pensions';
exports.GENERAL_ASSEMBLY_MEMBERS_PENSIONS = GENERAL_ASSEMBLY_MEMBERS_PENSIONS;
var JUDGES_PENSIONS = 'judges_pensions';
exports.JUDGES_PENSIONS = JUDGES_PENSIONS;
var COURT_EMPLOYEES_PENSIONS = 'court_employees_pensions';
exports.COURT_EMPLOYEES_PENSIONS = COURT_EMPLOYEES_PENSIONS;
var HOUSE_OF_CORRECTIONS_EMPLOYEES = 'house_of_corrections_employees';
exports.HOUSE_OF_CORRECTIONS_EMPLOYEES = HOUSE_OF_CORRECTIONS_EMPLOYEES;
var DISTRICT_ATTORNEY_PENSION = 'district_attorney_pension';
exports.DISTRICT_ATTORNEY_PENSION = DISTRICT_ATTORNEY_PENSION;
var ASSESSORS_PENSION = 'assessors_pension';
exports.ASSESSORS_PENSION = ASSESSORS_PENSION;
var PRIVATE_PENSION_PLAN = 'private_pension_plan';
exports.PRIVATE_PENSION_PLAN = PRIVATE_PENSION_PLAN;
var HIGHWAY_PATROL_PENSION = 'highway_patrol_pension';
exports.HIGHWAY_PATROL_PENSION = HIGHWAY_PATROL_PENSION;
var PUBLIC_SCHOOL_EMPLOYEE_PENSIONS = 'public_school_employee_pension';
exports.PUBLIC_SCHOOL_EMPLOYEE_PENSIONS = PUBLIC_SCHOOL_EMPLOYEE_PENSIONS;
var PAROCHIAL_EMPLOYEE_PENSION = 'parochial_employee_pension';
exports.PAROCHIAL_EMPLOYEE_PENSION = PAROCHIAL_EMPLOYEE_PENSION;
var SCHOOL_EMPLOYEE_PENSION = 'school_employee_pension';
exports.SCHOOL_EMPLOYEE_PENSION = SCHOOL_EMPLOYEE_PENSION;
var VOLUNTEER_FIREFIGHTERS_DEPENDENTS_FUND = 'volunteer_firefighters_dependents_fund';
exports.VOLUNTEER_FIREFIGHTERS_DEPENDENTS_FUND = VOLUNTEER_FIREFIGHTERS_DEPENDENTS_FUND;
var VOTING_REGISTRAR_PENSION = 'voting_registrar_pension';
exports.VOTING_REGISTRAR_PENSION = VOTING_REGISTRAR_PENSION;
var BAGGAGE_KEEPERS = 'baggage_keepers';
exports.BAGGAGE_KEEPERS = BAGGAGE_KEEPERS;
var OLD_AGE_ASSISTANCE = 'old_age_assistance';
exports.OLD_AGE_ASSISTANCE = OLD_AGE_ASSISTANCE;
var CONSERVATION_OFFICER = 'conservation_officer'; // Stock

exports.CONSERVATION_OFFICER = CONSERVATION_OFFICER;
var PUBLIC_STOCK = 'public_stock';
exports.PUBLIC_STOCK = PUBLIC_STOCK;
var PRIVATE_STOCK = 'private_stock'; // Tax credit

exports.PRIVATE_STOCK = PRIVATE_STOCK;
var INCOME_TAX_CREDIT = 'income_tax_credit';
exports.INCOME_TAX_CREDIT = INCOME_TAX_CREDIT;
var CHILD_CREDIT = 'child_credit'; // Tax refund

exports.CHILD_CREDIT = CHILD_CREDIT;
var FEDERAL_TAX_REFUND = 'federal_tax_refund';
exports.FEDERAL_TAX_REFUND = FEDERAL_TAX_REFUND;
var STATE_TAX_REFUND = 'state_tax_refund';
exports.STATE_TAX_REFUND = STATE_TAX_REFUND;
var LOCAL_TAX_REFUND = 'local_tax_refund'; // Trust

exports.LOCAL_TAX_REFUND = LOCAL_TAX_REFUND;
var SPENDTHRIFT_TRUST = 'spendthrift_trust';
exports.SPENDTHRIFT_TRUST = SPENDTHRIFT_TRUST;
var TUITION_TRUST = 'tuition_trust';
exports.TUITION_TRUST = TUITION_TRUST;
var FUNERAL_TRUST = 'funeral_trust';
exports.FUNERAL_TRUST = FUNERAL_TRUST;
var PERPETUAL_CARE_TRUST = 'perpetual_care_trust';
exports.PERPETUAL_CARE_TRUST = PERPETUAL_CARE_TRUST;
var PREPAID_COLLEGE_TRUST = 'prepaid_college_trust';
exports.PREPAID_COLLEGE_TRUST = PREPAID_COLLEGE_TRUST;
var CEMETARY_MERCHANDISE_TRUST = 'cemetray_merchandise_trust'; // Kansas
// ...

exports.CEMETARY_MERCHANDISE_TRUST = CEMETARY_MERCHANDISE_TRUST;
var TUITION_PROGRAM = 'tuition_program'; // Indiana

exports.TUITION_PROGRAM = TUITION_PROGRAM;
var SOUTH_CAROLINA_TUITION_PREPAYMENT_PROGRAM = 'south_carolina_tuition_prepayment_program'; // Savings Account

exports.SOUTH_CAROLINA_TUITION_PREPAYMENT_PROGRAM = SOUTH_CAROLINA_TUITION_PREPAYMENT_PROGRAM;
var HURRICANE_SAVINGS_ACCOUNT = 'hurricane_savings_account';
exports.HURRICANE_SAVINGS_ACCOUNT = HURRICANE_SAVINGS_ACCOUNT;
var ILLINOIS_COLLEGE_SAVINGS_POOL_ACCOUNT = 'illinois_college_savings_pool_account';
exports.ILLINOIS_COLLEGE_SAVINGS_POOL_ACCOUNT = ILLINOIS_COLLEGE_SAVINGS_POOL_ACCOUNT;
var THRIFT_SAVINGS_PLAN = 'thrift_savings_plan'; // Book

exports.THRIFT_SAVINGS_PLAN = THRIFT_SAVINGS_PLAN;
var SCHOOLBOOKS = 'schoolbooks';
exports.SCHOOLBOOKS = SCHOOLBOOKS;